import { generatePath } from 'react-router-dom';
import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_ASSET_DASHBOARD_LIST,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_ASSET_DASHBOARD_DATA,
} from '../constants';

const api = ({ solutionId, twinId }) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_ASSET_DASHBOARD_LIST, {
      solutionId,
      twinId,
    }),
  });

const dashboardList = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_ASSET_DASHBOARD_DATA,
  responseMapping: ResponseMapping.Default,
});

export default dashboardList;
